import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import regionService from '../../services/region.service';
import '../../styles/AddPages.css';

const ViewRegionDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [region, setRegion] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRegion = async () => {
      try {
        const res = await regionService.getRegionById(id);
        if (res.success) setRegion(res.data);
        else setError('Region not found');
      } catch {
        setError('Failed to fetch region');
      } finally {
        setLoading(false);
      }
    };
    fetchRegion();
  }, [id]);

  const formatDate = (d) =>
    d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';

  if (loading) return <div style={{ padding: 60, textAlign: 'center', color: '#6c757d' }}>Loading...</div>;
  if (error)   return <div style={{ padding: 60, textAlign: 'center', color: '#e53e3e' }}>{error}</div>;
  if (!region) return null;

  const DetailItem = ({ label, value }) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <span style={{ fontSize: 11, fontWeight: 700, color: '#6c757d', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
        {label}
      </span>
      <span style={{ fontSize: 15, color: '#1a1a1a' }}>{value || '—'}</span>
    </div>
  );

  return (
    <div className="add-region-page">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><a href="/dashboard/overview">Dashboard</a></li>
          <li className="breadcrumb-item"><a href="/region/view">Regions</a></li>
          <li className="breadcrumb-item active">{region.name}</li>
        </ol>
      </nav>

      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h4 className="page-title">Region Details</h4>
        <div style={{ display: 'flex', gap: 10 }}>
          <button className="btn btn-secondary" onClick={() => navigate('/region/view')}>← Back</button>
          <button className="btn btn-primary"   onClick={() => navigate(`/region/edit/${id}`)}>✏️ Edit Region</button>
        </div>
      </div>

      <div className="form-card">
        {/* Hero row */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24,
          padding: '16px 20px', background: '#f0fdf4', borderRadius: 10, border: '1px solid #bbf7d0' }}>
          <div style={{ width: 48, height: 48, borderRadius: '50%', background: '#48bb78',
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, flexShrink: 0 }}>
            🗺️
          </div>
          <div>
            <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: '#1a1a1a' }}>{region.name}</h2>
            <p style={{ margin: 0, fontSize: 13, color: '#6c757d' }}>{region.company?.name || '—'}</p>
          </div>
        </div>

        {/* Detail grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24 }}>
          <DetailItem label="Region Name" value={region.name} />
          <DetailItem label="Company"     value={region.company?.name} />
          <DetailItem label="Added Date"  value={formatDate(region.createdAt)} />
          {region.updatedAt && region.updatedAt !== region.createdAt && (
            <DetailItem label="Last Updated" value={formatDate(region.updatedAt)} />
          )}
          {region.createdBy && (
            <DetailItem label="Created By"
              value={`${region.creator?.firstName || ''} ${region.creator?.lastName || ''}`.trim() || region.createdBy} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewRegionDetail;